(function wdProfileAddressCombobox() {
  const VERSION = 9;
  if (window.__wdProfileAddressComboboxVersion === VERSION) return;

  if (window.__wdProfileAddressComboboxOnInput) {
    document.removeEventListener('input', window.__wdProfileAddressComboboxOnInput, true);
    document.removeEventListener('keydown', window.__wdProfileAddressComboboxOnKeydown, true);
  }
  if (window.__wdProfileAddressComboboxDirectCleanup) {
    window.__wdProfileAddressComboboxDirectCleanup();
  }

  window.__wdProfileAddressComboboxVersion = VERSION;

  const CITY_INPUT_ID = 'wd-profile-city-input';
  const STREET_INPUT_ID = 'wd-profile-street-input';
  const CITY_LIST_ID = 'wdProfileCitySuggestionList';
  const STREET_LIST_ID = 'wdProfileStreetSuggestionList';
  const CITY_STATUS_ID = 'wdProfileCityStatus';
  const STREET_STATUS_ID = 'wdProfileStreetStatus';
  const CITY_LOADER_ID = 'cityLoader';
  const STREET_LOADER_ID = 'streetLoader';


  let cityToken = 0;
  let streetToken = 0;
  let cityActive = -1;
  let streetActive = -1;
  let citySuggestions = [];
  let streetSuggestions = [];
  let announceTimer = null;
  let suppressBlurCloseUntil = 0;

  // Announce only for keyboard option moves / selection (not on every keystroke).
  // wedev change (a11y): the message used to go into this region and a second one on the body
  // at the same time, so a reader said every announcement twice.
  function announce(statusId, message) {
    if (!message) return;
    const fieldStatus = document.getElementById(statusId);
    if (!fieldStatus) return;

    fieldStatus.textContent = '';
    if (announceTimer) clearTimeout(announceTimer);

    announceTimer = window.setTimeout(() => {
      fieldStatus.textContent = message;
    }, 20);
  }

  /**
   * wedev change (a11y): says how many suggestions arrived. It goes into a freshly inserted
   * alert node rather than a live region, because the list opens at the same moment the
   * combobox reports itself as expanded, and that state announcement swallows text sitting in
   * a region that already existed. The node lives next to the input so a modal dialog cannot
   * put it out of the reader's reach.
   */
  function alertSuggestionCount(input, count) {
    if (!input || !count) return;

    const previous = input.parentElement?.querySelector('.wd-profile-address-sr-alert');

    if (previous) previous.remove();

    const node = document.createElement('div');
    node.className = 'wd-profile-address-sr-alert visually-hidden';
    node.setAttribute('role', 'alert');
    node.textContent = count === 1 ? 'הצעה אחת, בחירה במקשי החצים' : `${count} הצעות, בחירה במקשי החצים`;
    input.insertAdjacentElement('afterend', node);
    window.setTimeout(() => node.remove(), 4000);
  }

  function optionLabel(item, labelKey) {
    return typeof item === 'string' ? item.trim() : String(item[labelKey] || '').trim();
  }

  function syncHostSuggestions(kind, items) {
    const input = document.getElementById(kind === 'city' ? CITY_INPUT_ID : STREET_INPUT_ID);
    const host = input?.closest('wd-profile-tab');
    if (!host) return;
    if (kind === 'city') host._citySuggestions = items;
    else host._streetSuggestions = items;
  }

  function setActive(listId, inputId, statusId, index) {
    const list = document.getElementById(listId);
    const input = document.getElementById(inputId);
    if (!list || !input) return index;
    const options = [...list.querySelectorAll('[role="option"]')];
    options.forEach((opt, i) => opt.setAttribute('aria-selected', String(i === index)));
    if (index >= 0 && options[index]) {
      input.setAttribute('aria-activedescendant', options[index].id);
      // Scroll list container only — avoid scrollIntoView focus/blur side effects in the modal.
      const opt = options[index];
      const listTop = list.scrollTop;
      const optTop = opt.offsetTop;
      const optBottom = optTop + opt.offsetHeight;
      if (optTop < listTop) list.scrollTop = optTop;
      else if (optBottom > listTop + list.clientHeight) list.scrollTop = optBottom - list.clientHeight;
      // wedev change (a11y): no announcement here. aria-activedescendant already makes the
      // reader say the active option, so a message of our own said each one a second time.
    } else {
      input.removeAttribute('aria-activedescendant');
    }
    return index;
  }

  function hideList(listId, inputId) {
    const list = document.getElementById(listId);
    const input = document.getElementById(inputId);
    if (list) {
      list.style.display = 'none';
      list.querySelectorAll('[role="option"]').forEach((opt) => opt.setAttribute('aria-selected', 'false'));
    }
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
  }

  function seedSelectedOption(list, label, id) {
    if (!list) return;
    list.innerHTML = '';
    const li = document.createElement('li');
    li.setAttribute('role', 'option');
    li.id = id;
    li.setAttribute('aria-selected', 'false');
    li.textContent = label;
    list.appendChild(li);
    list.style.display = 'none';
  }

  function selectCity(item) {
    const input = document.getElementById(CITY_INPUT_ID);
    const street = document.getElementById(STREET_INPUT_ID);
    const list = document.getElementById(CITY_LIST_ID);
    const name = optionLabel(item, 'שם_ישוב');
    if (input) {
      input.value = name;
      input.focus({ preventScroll: true });
    }
    if (street) street.disabled = false;
    seedSelectedOption(list, name, 'wd-profile-city-opt-0');
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    cityActive = -1;
    citySuggestions = [{ 'שם_ישוב': name }];
    syncHostSuggestions('city', citySuggestions);
    announce(CITY_STATUS_ID, `נבחר יישוב ${name}`);
  }

  function selectStreet(item) {
    const input = document.getElementById(STREET_INPUT_ID);
    const list = document.getElementById(STREET_LIST_ID);
    const name = optionLabel(item, 'שם_רחוב');
    if (input) {
      input.value = name;
      input.focus({ preventScroll: true });
    }
    seedSelectedOption(list, name, 'wd-profile-street-opt-0');
    if (input) {
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    streetActive = -1;
    streetSuggestions = [{ 'שם_רחוב': name }];
    syncHostSuggestions('street', streetSuggestions);
    announce(STREET_STATUS_ID, `נבחר רחוב ${name}`);
  }

  function renderOptions(listId, inputId, statusId, items, labelKey, idPrefix, onPick) {
    const list = document.getElementById(listId);
    const input = document.getElementById(inputId);
    if (!list || !input) return;
    list.innerHTML = '';
    items.forEach((item, index) => {
      const label = optionLabel(item, labelKey);
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.id = `${idPrefix}-${index}`;
      li.setAttribute('aria-selected', 'false');
      li.textContent = label;
      li.addEventListener('mousedown', (ev) => {
        // Keep focus on the input so arrow navigation / blur logic stay stable.
        ev.preventDefault();
      });
      li.addEventListener('click', () => onPick(item));
      list.appendChild(li);
    });
    list.style.setProperty('display', 'block');
    input.setAttribute('aria-expanded', 'true');
    input.removeAttribute('aria-activedescendant');
    // Do not announce option names here — only when user moves with arrows.
    alertSuggestionCount(input, items.length);
  }

  function isArrowKey(e) {
    return e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.code === 'ArrowDown' || e.code === 'ArrowUp';
  }

  async function onCityInput(input) {
    const value = input.value.trim();
    const street = document.getElementById(STREET_INPUT_ID);
    if (street) {
      street.disabled = true;
      street.value = '';
    }
    hideList(STREET_LIST_ID, STREET_INPUT_ID);
    const streetList = document.getElementById(STREET_LIST_ID);
    if (streetList) streetList.innerHTML = '';

    if (value.length < 2) {
      hideList(CITY_LIST_ID, CITY_INPUT_ID);
      const list = document.getElementById(CITY_LIST_ID);
      if (list) list.innerHTML = '';
      citySuggestions = [];
      cityActive = -1;
      syncHostSuggestions('city', []);
      return;
    }

    const token = ++cityToken;
    const loader = document.getElementById(CITY_LOADER_ID);
    if (loader) loader.style.display = 'block';
    hideList(CITY_LIST_ID, CITY_INPUT_ID);

    try {
      const q = encodeURIComponent(JSON.stringify({ 'שם_ישוב': value }));
      const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=d4901968-dad3-4845-a9b0-a57d027f11ab&limit=25&q=${q}`;
      const response = await fetch(url);
      const result = await response.json();
      if (token !== cityToken) return;
      if (loader) loader.style.display = 'none';

      const records = (result.success ? result.result.records : []).filter((city) =>
        String(city['שם_ישוב'] || '').trim().includes(value)
      );
      citySuggestions = records;
      cityActive = -1;
      syncHostSuggestions('city', records);

      if (records.length) {
        renderOptions(
          CITY_LIST_ID, CITY_INPUT_ID, CITY_STATUS_ID, records,
          'שם_ישוב', 'wd-profile-city-opt', selectCity
        );
      } else {
        hideList(CITY_LIST_ID, CITY_INPUT_ID);
      }
    } catch (err) {
      if (token !== cityToken) return;
      if (loader) loader.style.display = 'none';
      hideList(CITY_LIST_ID, CITY_INPUT_ID);
      console.error('[wd-profile-address-combobox] city fetch failed', err);
    }
  }

  async function onStreetInput(input) {
    if (input.disabled) return;
    const value = input.value.trim();
    const city = document.getElementById(CITY_INPUT_ID)?.value.trim() || '';

    if (value.length < 2 || !city) {
      hideList(STREET_LIST_ID, STREET_INPUT_ID);
      const list = document.getElementById(STREET_LIST_ID);
      if (list) list.innerHTML = '';
      streetSuggestions = [];
      streetActive = -1;
      syncHostSuggestions('street', []);
      return;
    }

    const token = ++streetToken;
    const loader = document.getElementById(STREET_LOADER_ID);
    if (loader) loader.style.display = 'block';
    hideList(STREET_LIST_ID, STREET_INPUT_ID);

    try {
      const q = encodeURIComponent(JSON.stringify({ 'שם_ישוב': city, 'שם_רחוב': value }));
      const url = `https://data.gov.il/api/3/action/datastore_search?resource_id=a7296d1a-f8c9-4b70-96c2-6ebb4352f8e3&limit=2300&q=${q}`;
      const response = await fetch(url);
      const result = await response.json();
      if (token !== streetToken) return;
      if (loader) loader.style.display = 'none';

      const records = (result.result?.records || []).filter((street) =>
        String(street['שם_רחוב'] || '').trim().toLowerCase().includes(value.toLowerCase())
      );
      streetSuggestions = records;
      streetActive = -1;
      syncHostSuggestions('street', records);

      if (records.length) {
        renderOptions(
          STREET_LIST_ID, STREET_INPUT_ID, STREET_STATUS_ID, records,
          'שם_רחוב', 'wd-profile-street-opt', selectStreet
        );
      } else {
        hideList(STREET_LIST_ID, STREET_INPUT_ID);
      }
    } catch (err) {
      if (token !== streetToken) return;
      if (loader) loader.style.display = 'none';
      hideList(STREET_LIST_ID, STREET_INPUT_ID);
      console.error('[wd-profile-address-combobox] street fetch failed', err);
    }
  }

  function onCityKeydown(e) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.id !== CITY_INPUT_ID) return;
    // Guard: document capture + direct bind must not both advance the index.
    if (e.__wdProfileCityArrowHandled) return;
    const list = document.getElementById(CITY_LIST_ID);
    if (!list) return;
    const options = [...list.querySelectorAll('[role="option"]')];
    const open = list.style.display === 'block' || getComputedStyle(list).display !== 'none';
    const isDown = e.key === 'ArrowDown' || e.code === 'ArrowDown';
    const isUp = e.key === 'ArrowUp' || e.code === 'ArrowUp';
    const isEnter = e.key === 'Enter' || e.code === 'Enter';
    const isEsc = e.key === 'Escape' || e.code === 'Escape';

    if (isDown || isUp) {
      if (!options.length) return;
      e.preventDefault();
      e.stopPropagation();
      e.__wdProfileCityArrowHandled = true;
      suppressBlurCloseUntil = Date.now() + 500;
      list.style.setProperty('display', 'block');
      input.setAttribute('aria-expanded', 'true');
      if (isDown) {
        cityActive = setActive(
          CITY_LIST_ID, CITY_INPUT_ID, CITY_STATUS_ID,
          cityActive < 0 ? 0 : (cityActive + 1) % options.length
        );
      } else {
        cityActive = setActive(
          CITY_LIST_ID, CITY_INPUT_ID, CITY_STATUS_ID,
          cityActive < 0 ? options.length - 1 : (cityActive - 1 + options.length) % options.length
        );
      }
      return;
    }
    if (isEnter && open) {
      e.preventDefault();
      e.stopPropagation();
      e.__wdProfileCityArrowHandled = true;
      if (cityActive >= 0 && citySuggestions[cityActive]) selectCity(citySuggestions[cityActive]);
      else hideList(CITY_LIST_ID, CITY_INPUT_ID);
      return;
    }
    if (isEsc && open) {
      e.preventDefault();
      e.stopPropagation();
      e.__wdProfileCityArrowHandled = true;
      hideList(CITY_LIST_ID, CITY_INPUT_ID);
      cityActive = -1;
    }
  }

  function onStreetKeydown(e) {
    const input = e.target;
    if (!(input instanceof HTMLInputElement) || input.id !== STREET_INPUT_ID || input.disabled) return;
    if (e.__wdProfileStreetArrowHandled) return;
    const list = document.getElementById(STREET_LIST_ID);
    if (!list) return;
    const options = [...list.querySelectorAll('[role="option"]')];
    const open = list.style.display === 'block' || getComputedStyle(list).display !== 'none';
    const isDown = e.key === 'ArrowDown' || e.code === 'ArrowDown';
    const isUp = e.key === 'ArrowUp' || e.code === 'ArrowUp';
    const isEnter = e.key === 'Enter' || e.code === 'Enter';
    const isEsc = e.key === 'Escape' || e.code === 'Escape';

    if (isDown || isUp) {
      if (!options.length) return;
      e.preventDefault();
      e.stopPropagation();
      e.__wdProfileStreetArrowHandled = true;
      suppressBlurCloseUntil = Date.now() + 500;
      list.style.setProperty('display', 'block');
      input.setAttribute('aria-expanded', 'true');
      if (isDown) {
        streetActive = setActive(
          STREET_LIST_ID, STREET_INPUT_ID, STREET_STATUS_ID,
          streetActive < 0 ? 0 : (streetActive + 1) % options.length
        );
      } else {
        streetActive = setActive(
          STREET_LIST_ID, STREET_INPUT_ID, STREET_STATUS_ID,
          streetActive < 0 ? options.length - 1 : (streetActive - 1 + options.length) % options.length
        );
      }
      return;
    }
    if (isEnter && open) {
      e.preventDefault();
      e.stopPropagation();
      e.__wdProfileStreetArrowHandled = true;
      if (streetActive >= 0 && streetSuggestions[streetActive]) selectStreet(streetSuggestions[streetActive]);
      else hideList(STREET_LIST_ID, STREET_INPUT_ID);
      return;
    }
    if (isEsc && open) {
      e.preventDefault();
      e.stopPropagation();
      e.__wdProfileStreetArrowHandled = true;
      hideList(STREET_LIST_ID, STREET_INPUT_ID);
      streetActive = -1;
    }
  }

  // Prefer direct input listeners. Document capture is a backup only.
  function onKeydown(e) {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.id === CITY_INPUT_ID || t.id === STREET_INPUT_ID) {
      // If direct bind already handled this event, skip.
      if (e.__wdProfileCityArrowHandled || e.__wdProfileStreetArrowHandled) return;
      if (t.id === CITY_INPUT_ID) onCityKeydown(e);
      else onStreetKeydown(e);
    }
  }

  function onInput(e) {
    const t = e.target;
    if (!(t instanceof HTMLInputElement)) return;
    if (t.dataset.wdAcKeyBound === String(VERSION)) return; // direct input listener owns it
    if (t.id === CITY_INPUT_ID) onCityInput(t);
    else if (t.id === STREET_INPUT_ID) onStreetInput(t);
  }

  function onCityBlur() {
    window.setTimeout(() => {
      if (Date.now() < suppressBlurCloseUntil) return;
      const input = document.getElementById(CITY_INPUT_ID);
      if (input && document.activeElement === input) return;
      hideList(CITY_LIST_ID, CITY_INPUT_ID);
      cityActive = -1;
    }, 200);
  }

  function onStreetBlur() {
    window.setTimeout(() => {
      if (Date.now() < suppressBlurCloseUntil) return;
      const input = document.getElementById(STREET_INPUT_ID);
      if (input && document.activeElement === input) return;
      hideList(STREET_LIST_ID, STREET_INPUT_ID);
      streetActive = -1;
    }, 200);
  }

  function bindDirect() {
    const city = document.getElementById(CITY_INPUT_ID);
    const street = document.getElementById(STREET_INPUT_ID);
    const cleanups = [];

    if (city && city.dataset.wdAcKeyBound !== String(VERSION)) {
      city.dataset.wdAcKeyBound = String(VERSION);
      const onCityKey = (e) => onCityKeydown(e);
      const onCityIn = () => onCityInput(city);
      city.addEventListener('keydown', onCityKey);
      city.addEventListener('input', onCityIn);
      city.addEventListener('blur', onCityBlur);
      cleanups.push(() => {
        city.removeEventListener('keydown', onCityKey);
        city.removeEventListener('input', onCityIn);
        city.removeEventListener('blur', onCityBlur);
        delete city.dataset.wdAcKeyBound;
      });
    }

    if (street && street.dataset.wdAcKeyBound !== String(VERSION)) {
      street.dataset.wdAcKeyBound = String(VERSION);
      const onStreetKey = (e) => onStreetKeydown(e);
      const onStreetIn = () => onStreetInput(street);
      street.addEventListener('keydown', onStreetKey);
      street.addEventListener('input', onStreetIn);
      street.addEventListener('blur', onStreetBlur);
      cleanups.push(() => {
        street.removeEventListener('keydown', onStreetKey);
        street.removeEventListener('input', onStreetIn);
        street.removeEventListener('blur', onStreetBlur);
        delete street.dataset.wdAcKeyBound;
      });
    }

    window.__wdProfileAddressComboboxDirectCleanup = () => {
      cleanups.forEach((fn) => fn());
    };
  }

  window.__wdProfileAddressComboboxOnInput = onInput;
  window.__wdProfileAddressComboboxOnKeydown = onKeydown;
  document.addEventListener('input', onInput, true);
  document.addEventListener('keydown', onKeydown, true);
  bindDirect();

  // Re-bind when address modal is shown (inputs exist but may be rebound after edit).
  const modal = document.querySelector('.wd-profile-tab-form-address-modal');
  if (modal && !modal.dataset.wdAcV8Observed) {
    modal.dataset.wdAcV8Observed = '1';
    new MutationObserver(() => bindDirect()).observe(modal, {
      attributes: true,
      attributeFilter: ['style'],
    });
  }

  window.wdEnsureProfileAddressCombobox = function wdEnsureProfileAddressCombobox() {
    bindDirect();
    return {
      version: VERSION,
      cityInput: !!document.getElementById(CITY_INPUT_ID),
      cityList: !!document.getElementById(CITY_LIST_ID),
      cityOptions: document.getElementById(CITY_LIST_ID)?.querySelectorAll('[role="option"]')?.length || 0,
    };
  };

  console.info('[wd-profile-address-combobox] bound v' + VERSION);
})();
